import CryptoJS from 'crypto-js'

function encrypt<T>(props: T): string {
	const paramsEncrypted = CryptoJS.AES.encrypt(
		JSON.stringify(props),
		getKey(),
		{
			format: CryptoJSAesJson
		}
	).toString()

	// console.log('encrypted', paramsEncrypted)

	decrypt(paramsEncrypted)

	return paramsEncrypted
}

// In Some steps we will not have the token
function getKey() {
	// const token = store.getState().token

	// return token.accessToken

	// TODO: get the token from other place
	return 'Eydl1C5mT6PIqBZMmsCjopfDlw'
}

function decrypt(code: string) {

	const bytes = CryptoJS.AES.decrypt(code, getKey(), {
		format: CryptoJSAesJson
	})

	const decryptedCode = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

	// console.log('decrypted', decryptedCode)
}

var CryptoJSAesJson = {
	stringify: function (cipherParams: any) {
		var j: any = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) }
		if (cipherParams.iv) j.iv = cipherParams.iv.toString()
		if (cipherParams.salt) j.s = cipherParams.salt.toString()
		return JSON.stringify(j)
	},
	parse: function (jsonStr: any) {
		var j = JSON.parse(jsonStr)
		var cipherParams = CryptoJS.lib.CipherParams.create({
			ciphertext: CryptoJS.enc.Base64.parse(j.ct)
		})
		if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
		if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
		return cipherParams
	}
}

export { encrypt, decrypt }
